import pako from 'pako';

export function decompressBitmapFontFile(buffer) {
  const data = pako.inflate(buffer, { to: 'string' });
  const fntLengthString = data.split('info')[0];
  const fntLength = parseInt(fntLengthString, 10);
  const fntStart = fntLengthString.length;
  const fnt = data.substr(fntStart, fntLength);
  const image = new Image(); // We are not waiting for onload here, it should happen instantly but look here if we see bugs.
  image.src = data.substr(fntStart + fntLength, data.length);
  return { image: image, fnt: fnt };
}

export function compressBitmapFontFile(fnt, image) {
  const compressed = new pako.Deflate({});
  compressed.push(fnt.length.toString(), false);
  compressed.push(fnt, false);
  compressed.push(image, true);
  return new File(['bitm', compressed.result.buffer], 'bitmap.font');
}
